import {
  DASHBOARD_LOADING,
  FETCH_INVOICE_SUMMARY_SUCCESS,
  DASHBOARD_ERROR,
  CLEAR_DASHBOARD_DATA,
  REGIONAL_DASHBOARD_LOADING,
  REGIONAL_DASHBOARD_SUCCESS,
  REGIONAL_DASHBOARD_ERROR,
  CLEAR_REGIONAL_DASHBOARD_DATA,
  TAT_DASHBOARD_SUCCESS,
  PERFORMANCE_DASHBOARD_LOADING,
  PERFORMANCE_DASHBOARD_SUCCESS,
  PERFORMANCE_DASHBOARD_ERROR
} from '../../actions/dashboard';

// ** Initial State
const initialState = {
  GradationList: [],
  loading_Gradation: false,
  error_Gradation: '',

  PaymentCountList: [],
  loading_Payment: false,
  error_Payment: '',

  PaymentValueList: [],
  loading_PaymentValue: false,
  error_PaymentValue: '',

  PurchaseOrderList: [],
  loading_PurchaseOrder: false,
  error_PurchaseOrder: '',

  overall: null,
  perYear: [],
  monthlyData: [],
  cssList: [],
  loading: false,
  dateRange: null,
  pendingInvoices: [],
  workOrdersWithoutInvoice: [],
  lastPaymentClearedMonth: null,
  error: null,

  performanceData: [],
  performanceLoading: false,
  performanceError: null,

  regionalBusinessUnits: [],
  regionalLoading: false,
  regionalError: null
}

const dashbaordReducer = (state = initialState, action) => {
  switch (action.type) {
    // Gradation
    case 'Gradation_LOADING': {
      return {
        ...state,
        loading_Gradation: true,
        error_Gradation: ''
      }
    }
    case 'Gradation_SUCCESS': {
      return {
        ...state,
        GradationList: action.data,
        loading_Gradation: false
      }
    }
    case 'Gradation_ERROR': {
      return {
        ...state,
        loading_Gradation: false,
        error_Gradation: action.error
      }
    }

    // Payment
    case 'Payment_LOADING': {
      return {
        ...state,
        loading_Payment: true,
        error_Payment: ''
      }
    }
    case 'Payment_SUCCESS': {
      return {
        ...state,
        PaymentCountList: action.data,
        loading_Payment: false
      }
    }
    case 'Payment_ERROR': {
      return {
        ...state,
        loading_Payment: false,
        error_Payment: action.error
      }
    }

    // Payment Value
    case 'PaymentValue_LOADING': {
      return {
        ...state,
        loading_PaymentValue: true,
        error_PaymentValue: ''
      }
    }
    case 'PaymentValue_SUCCESS': {
      return {
        ...state,
        PaymentValueList: action.data,
        loading_PaymentValue: false
      }
    }
    case 'PaymentValue_ERROR': {
      return {
        ...state,
        loading_PaymentValue: false,
        error_PaymentValue: action.error
      }
    }

    // Purchase Order
    case 'PODashboard_LOADING': {
      return {
        ...state,
        loading_PurchaseOrder: true,
        error_PurchaseOrder: ''
      }
    }
    case 'PODashboard_SUCCESS': {
      return {
        ...state,
        PurchaseOrderList: action.data,
        loading_PurchaseOrder: false
      }
    }
    case 'PODashboard_ERROR': {
      return {
        ...state,
        loading_PurchaseOrder: false,
        error_PurchaseOrder: action.error
      }
    }
    case DASHBOARD_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: null
      };

    case FETCH_INVOICE_SUMMARY_SUCCESS:
      console.log('🎉 Reducer received data:', action.payload);
      return {
        ...state,
        overall: action.payload.overall,
        perYear: action.payload.perYear || [],
        monthlyData: action.payload.monthlyData || [],
        dateRange: action.payload.dateRange,
        pendingInvoices: action.payload.pendingInvoices || [],
        workOrdersWithoutInvoice: action.payload.workOrdersWithoutInvoice || [],
        lastPaymentClearedMonth: action.payload.lastPaymentClearedMonth,
        loading: false,
        error: null
      };

    case DASHBOARD_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case CLEAR_DASHBOARD_DATA:
      return {
        ...state,
        overall: null,
        perYear: [],
        monthlyData: [],
        cssList: [],
        loading: false,
        dateRange: null,
        pendingInvoices: [],
        workOrdersWithoutInvoice: [],
        lastPaymentClearedMonth: null,
        tatData: null,
        performanceData: [],
        performanceLoading: false,
        performanceError: null,
        error: null
      };

    case PERFORMANCE_DASHBOARD_LOADING:
      return {
        ...state,
        performanceLoading: action.payload,
        performanceError: null
      };

    case PERFORMANCE_DASHBOARD_SUCCESS:
      return {
        ...state,
        performanceData: action.payload,
        performanceLoading: false,
        performanceError: null
      };

    case PERFORMANCE_DASHBOARD_ERROR:
      return {
        ...state,
        performanceLoading: false,
        performanceError: action.payload
      };

    // ✅ ADD THESE NEW CASES FOR REGIONAL DASHBOARD
    case REGIONAL_DASHBOARD_LOADING:
      return {
        ...state,
        regionalLoading: true,
        regionalError: null
      };

    case REGIONAL_DASHBOARD_SUCCESS:
      console.log('🎉 Regional Dashboard Reducer received data:', action.payload);
      return {
        ...state,
        regionalBusinessUnits: action.payload.businessUnits || [],
        regionalLoading: false,
        regionalDateRange: action.payload.dateRange || null,
        regionalError: null
      };

    case TAT_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        tatData: action.payload,
        error: null
      };

    case REGIONAL_DASHBOARD_ERROR:
      return {
        ...state,
        regionalLoading: false,
        regionalError: action.payload
      };

    case CLEAR_REGIONAL_DASHBOARD_DATA:
      return {
        ...state,
        regionalBusinessUnits: [],
        regionalLoading: false,
        regionalError: null
      };

    default:
      return state
  }
}

export default dashbaordReducer
